import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {ApiService} from '../../../services/api.service';

@Component({
  selector: 'app-vendor-specific',
  templateUrl: './vendor-specific.component.html',
  styleUrls: ['./vendor-specific.component.css', '../myreports.component.css']
})
export class VendorSpecificComponent implements OnInit {

  public vendorSpecificReports: any;
  public reports: any;

  constructor(private route: ActivatedRoute,
              private apiService: ApiService) {
  }

  ngOnInit() {
	  this.route.queryParams.subscribe(params => {
	      if (params) {
	        this.vendorSpecificReports = this.apiService.vendorReports(params.vendor);
	        this.reports = this.vendorSpecificReports ? this.vendorSpecificReports.data : undefined;
	      }
    });
  }

}



// WEBPACK FOOTER //
// C:/Work/Projects/OnlineParser/web2-ui/src/app/reports/myReports/vendor-specific/vendor-specific.component.ts